// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b4f152ea","578":"3924380f"}[chunkId] + ".chunk.js";
};